import { render, staticRenderFns } from "./PhotoSwipe.vue.js?vue&type=template&id=a2218850!=!../../node_modules/vue-loader/lib/index.js??vue-loader-options!./PhotoSwipe.vue?vue&type=template&id=a2218850"
import script from "./PhotoSwipe.vue.js?vue&type=script&lang=js!=!../../node_modules/vue-loader/lib/index.js??vue-loader-options!./PhotoSwipe.vue?vue&type=script&lang=js"
export * from "./PhotoSwipe.vue.js?vue&type=script&lang=js!=!../../node_modules/vue-loader/lib/index.js??vue-loader-options!./PhotoSwipe.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports